import type { Language } from '@/types';

export const monthOptions = [
  { value: 1, label: { sv: 'Januari', en: 'January' } },
  { value: 2, label: { sv: 'Februari', en: 'February' } },
  { value: 3, label: { sv: 'Mars', en: 'March' } },
  { value: 4, label: { sv: 'April', en: 'April' } },
  { value: 5, label: { sv: 'Maj', en: 'May' } },
  { value: 6, label: { sv: 'Juni', en: 'June' } },
  { value: 7, label: { sv: 'Juli', en: 'July' } },
  { value: 8, label: { sv: 'Augusti', en: 'August' } },
  { value: 9, label: { sv: 'September', en: 'September' } },
  { value: 10, label: { sv: 'Oktober', en: 'October' } },
  { value: 11, label: { sv: 'November', en: 'November' } },
  { value: 12, label: { sv: 'December', en: 'December' } },
] as const;

export const weekdayOptions = [
  { value: 1, short: 'Mon', long: { sv: 'Mån', en: 'Mon' } },
  { value: 2, short: 'Tue', long: { sv: 'Tis', en: 'Tue' } },
  { value: 3, short: 'Wed', long: { sv: 'Ons', en: 'Wed' } },
  { value: 4, short: 'Thu', long: { sv: 'Tor', en: 'Thu' } },
  { value: 5, short: 'Fri', long: { sv: 'Fre', en: 'Fri' } },
  { value: 6, short: 'Sat', long: { sv: 'Lör', en: 'Sat' } },
  { value: 7, short: 'Sun', long: { sv: 'Sön', en: 'Sun' } },
] as const;

export const cadenceOptions = ['WEEKLY', 'BIWEEKLY', 'MONTHLY', 'EXACT_MONTHS', 'ONE_OFF'] as const;
export const modelTypeOptions = ['RECURRING_BLOCK', 'EXTRA_CLEANING_TEMPLATE'] as const;
export const parityOptions = ['ODD', 'EVEN'] as const;
export const weekInMonthOptions = ['1', '2', '3', '4', 'LAST'] as const;

export const allMonthValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const;
export const allWeekdayValues = [1, 2, 3, 4, 5, 6, 7] as const;

export function formatMonthLabel(month: number, language: Language) {
  return monthOptions.find((option) => option.value === month)?.label[language] ?? String(month);
}

export function formatWeekdayShortLabel(weekday: number) {
  return weekdayOptions.find((option) => option.value === weekday)?.short ?? String(weekday);
}
